<nexus-grid [data]="emails_model" [sort]="[{ 'field': 'created_date', 'dir': 'desc' }]">
    <kendo-grid-column field="sent_date" title="Date Sent" format="G" filter="date"></kendo-grid-column>
    <kendo-grid-column field="subject" title="Subject"></kendo-grid-column>
    <kendo-grid-column field="to_address" title="To Address"></kendo-grid-column>
    <kendo-grid-column field="cc_address" title="CC Address"></kendo-grid-column>
  </nexus-grid>